import { TextMultiValuedList } from '../../../TextMultiValuedList'
import { ListCell } from '../ListCell'

function TextListCell({ List = TextMultiValuedList, ...restProps }) {
  return <ListCell {...restProps} List={List} />
}

export default TextListCell
